import { render, staticRenderFns } from "./ShareWith.vue?vue&type=template&id=0484efa4&"
import script from "./ShareWith.vue?vue&type=script&lang=js&"
export * from "./ShareWith.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/opt/buildhome/repo/components/global/Button.vue').default})
